<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<app-loader *ngIf="!dataIsLoaded"></app-loader>


<section class="main-side-nav  sumarries-container"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <header *ngIf="myUser.sharedPlanUserId">
                    <span>Shared Plan <i class="fa fas fa-chevron-right"></i></span>
                    <app-breadcrumb [pageName]="'Financial Summaries '" [isTopLevel]="true"></app-breadcrumb>
                    <span class="breadrumb-delegate-name">- {{myUser.delegate.clientName}}</span>
                </header>
                <header *ngIf="!myUser.sharedPlanUserId">
                    <span>My Plan <i class="fa fas fa-chevron-right"></i></span>
                    <app-breadcrumb [pageName]="'Financial Summaries '" [isTopLevel]="true"></app-breadcrumb>
                </header>
            </div>
            <div class="title-container">
                <h1>Financial Summaries</h1>
            </div>
        </section>
        <section *ngIf="dataIsLoaded"
            class="container apply-joint-owership-container margin-upside-down">
            <div class="apply-joint-owership-calculation">
                <!-- <div class="apply-joint-owership-text">
                    <div style="display:none;" class="svg-container help-btn-svg-container"
                        ngbTooltip="If you have jointly owned items in your plan, selecting this option will include the joint owner's share in your Financial Summary."
                        placement="top">
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 832.46 905" width="30px">

                            <path
                                d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                            <path
                                d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                transform="translate(-95.77 -59.5)" fill="#fff" />
                            <path
                                d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                            <path
                                d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                transform="translate(-95.77 -59.5)" class="svg-sign" />
                        </svg>
                    </div>


                    <div *ngIf="statusTooltipMobile" class="container-tooltip-show-mobile">
                        <div class="tooltip-show-mobile">Property income is shown net of related expenses e.g. mortgage
                            payments.</div>
                    </div>
                    <div class="info-mark-mobile" *ngIf="questionMarkMobile"
                        (click)="statusTooltipMobile = !statusTooltipMobile">
                        <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 832.46 905" width="30px">

                                <path
                                    d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                                    transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                                <path
                                    d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                                    transform="translate(-95.77 -59.5)" fill="#fff" />
                                <path
                                    d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                                <path
                                    d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                                    transform="translate(-95.77 -59.5)" class="svg-sign" />
                            </svg>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="view-owners-list-stat-button">
					<input type="checkbox" class="mytoggle" id="customSwitches_1" [(ngModel)]="jointOwnersStats"
						(change)="toggledViewJointOwnersStats(jointOwnersStats)">
					<label for="customSwitches_1" id="lbl_1" class="mytogglelabel"></label>
					<div *ngIf="jointOwnersStats">Yes</div>
					<div *ngIf="!jointOwnersStats">No</div>
				</div> -->
                <div class="selected-owners-list">
                    <div class="selected-owner" *ngFor="let selectedOwner of financialSummarySelectedOwners">
                        {{selectedOwner.first}} {{selectedOwner.last}} 
                    </div>
                </div>
                <div class="dropdown" (click)="openOwnersListMenu($event)" id="openOwnersListMenu"
                    [ngClass]="statusOwnersListMenu? 'dropdown-collapsed' : ''">
                    <div class="owners-list-dropdown">
                        <div class="icon" [ngClass]="statusOwnersListMenu ? 'owners-list-menu-icon-collapsed' : ''">
                            <div class="select-owner">
                                <span>Select Owners</span>
                                <i class="fa fas fa-chevron-down chevron-down"
                                    [ngClass]="statusOwnersListMenu ? 'chevron-collapsed' : ''"></i>
                            </div>
                        </div>
                        <div class="owners-list-container"
                            [ngClass]="{'display-owners-list-container': statusOwnersListMenu}">
                            <div class="owner" *ngFor="let owner of ownersWithProperty; let i = index">
                                <label class="check-label" [for]="'jointOwner'+i">
                                    <span>{{owner.first}} {{owner.last}}</span>
                                    <input type="checkbox" [id]="'jointOwner'+i" [name]="owner" class="form-check-input"
                                        (change)="getCurrentOwnerSelected($event,owner)"
                                        [checked]="selectedOwners[owner.first + owner.last]">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section *ngIf="noItems == true">
            <section class="no-items">
                <div class="empty-grid-container">
                    <img src="../../assets/img/{{themeService.theme}}/donut-chart.svg" alt="Section Logo" width="130px">
                    <h1 class="title">No values to show yet</h1>
                    <div class="info" (click)="statusExplanations = !statusExplanations">
                        <div class="svg-container help-btn-svg-container">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="30px"
                                viewBox="0 0 832.46 905">

                                <path
                                    d="M821.24,842.05c-44.62,44.62-84.61,78-137.16,98.8-19.58,7.77-49.17,13.79-69.47,18-122.82,25.39-256.92-6-379.44-128.5C92.46,687.62,88.24,383,243.16,235.21,420.63,65.87,665.57,92.86,821.24,248.53,983.08,410.37,983.08,680.21,821.24,842.05Z"
                                    transform="translate(-110.16 -62)" opacity="0.3" />
                                <path
                                    d="M794.26,774.53c-44,44-83.44,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73-140.74-140.73-144.9-441.1,7.89-586.89,175-167,416.57-140.38,570.08,13.14C953.86,348.82,953.86,614.93,794.26,774.53Z"
                                    transform="translate(-110.16 -62)" class="svg-background" />
                                <g>
                                    <path
                                        d="M617.21,321.54c-12.72-21.24-39.49-47.33-94.76-51.09-60.22-4.11-106.7,26-130.89,84.73-2.86,6.94-1.31,14.32,4.36,20.78,9.39,10.7,29.86,18.15,38.28,15.91,9-2.41,13.66-10.09,18.56-18.21,5.4-9,12.11-20.11,27.08-29.81,16.56-10.75,36.57-8.07,47-5.52,18.75,4.58,31.32,13.94,34.26,19.12,6.75,11.89,9.8,44.62-26.93,83.39-29.61,31.28-44.63,65.83-44.63,102.71v34.87c0,6.94,4.1,12.62,11.26,15.58,4.57,1.9,10.82,2.68,17.38,2.68,13.7,0,28.77-3.43,32.68-7.34.16-.16.28-.25.37-.33,4.08-3.34,3.66-7.08,3.32-10.09-.39-3.45-1.41-12.61-1.41-37.17,0-25.35,15.47-43.86,33.39-65.3,12.51-15,25.46-30.47,34.17-49.82C636.46,391.68,635.11,351.41,617.21,321.54Z"
                                        transform="translate(-110.16 -62)" class="svg-sign" />
                                    <path
                                        d="M531.23,622.46c-16.81-2.08-32.75,5.89-39.67,19.83-6.83,13.77-6.67,28.4.45,40.14a35,35,0,0,0,29.3,17.08h1.49c9.78,0,26.12-2,36.06-14.09,4.76-5.78,9.67-16.18,6-32.94C561.33,636.1,548.43,624.59,531.23,622.46Z"
                                        transform="translate(-110.16 -62)" class="svg-sign" />
                                </g>
                            </svg>
                        </div>
                        <div class="info-text">Learn More</div>
                    </div>
                </div>
                <div class="desktop-explanation dynamic-explanation"
                    [ngClass]="statusExplanations ? 'explanationDesktopCollapsed' : '' ">
                    <div class="container">
                        <div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
                            <img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
                        </div>
                        <img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="Section Logo"
                            width="170px">
                        <div class="title">About Financial Summaries</div>
                        <p>Financial summaries makes it easy for you to keep track of everything you have.</p>
                        <p>It automatically calculates your own personal balance sheet and income statement, so you can
                            enjoy a single view of all your assets, debts, incomes and expenses. </p>
                    </div>
                </div>
                <div class="mobile-explanation dynamic-explanation"
                    [ngClass]="statusExplanations ? 'explanationMobileCollapsed' : '' ">
                    <div class="container">
                        <div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
                            <img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
                        </div>
                        <img src="../../assets/img/donut-chart.svg" alt="Section Logo" width="170px">
                        <div class="title">About Financial Summaries</div>
                        <p>Financial summaries makes it easy for you to keep track of everything you have.</p>
                        <p>It automatically calculates your own personal balance sheet and income statement, so you can
                            enjoy a single view of all your assets, debts, incomes and expenses. </p>
                    </div>
                </div>
            </section>
        </section>
        <section *ngIf="dataIsLoaded && noItems == false && isOwnerSelected">
            <section class="all-sumarries">
                <section class="details-sumarries">
                    <div class="details-item">
                        <app-financial-summaries-net-worth [assets]="assets" [debts]="debts">
                        </app-financial-summaries-net-worth>
                    </div>
                    <div class="details-item">
                        <app-financial-summaries-net-income [income]="income" [expense]="expense">
                        </app-financial-summaries-net-income>
                    </div>
                    <!--					<div class="details-item">-->
                    <!--						<app-financial-summaries-properties [myCategoriesBalance]="myCategoriesBalance">-->
                    <!--						</app-financial-summaries-properties>-->
                    <!--					</div>-->
                    <!-- <div class="details-item">
						<app-financial-summaries-items>
						</app-financial-summaries-items>
					</div> -->
                </section>
                <section class="total-summaries">
                    <div>
                        <div class="details-item" *ngIf="financialSummaryMode">
                            <app-financial-summaries-section-items [myCategoriesBalance]="myCategoriesBalance"
                                [jointOwnershipCalc]="jointOwnersStats">
                            </app-financial-summaries-section-items>
                        </div>
                        <div class="details-item view-box-details-item"
                            *ngIf="financialSummaryMode && showSectionViewBox">
                            <app-section-view-box [myCategoriesBalance]="myCategoriesBalance"
                                [jointOwnersStats]="jointOwnersStats">
                            </app-section-view-box>
                        </div>
                        <div *ngIf="!financialSummaryMode">
                            <section class="dynamic-collapse">
                                <section class="dynamic-collapse-main">
                                    <div class="view-info">
                                        <app-view-box [Id]="itemId" [templateName]="propertyTemplateName"
                                            [financialSummary]="'Yes'">
                                        </app-view-box>
                                    </div>
                                </section>
                            </section>
                        </div>
                    </div>
                </section>
            </section>
        </section>
        <section class="warning" *ngIf="!isOwnerSelected">
            <div>You must choose at least one owner to see the details of the financial summary.</div>
        </section>
    </section>
</section>
